import { type PropsWithChildren, useEffect } from "react";
import { AdminNavbar } from "@/pages/admin/admin-navbar";

export const Layout = ({ children }: PropsWithChildren) => {
  useEffect(() => {
    document.documentElement.style.setProperty("--sidebar-top-offset", "48px");
    return () => {
      document.documentElement.style.removeProperty("--sidebar-top-offset");
    };
  }, []);

  return (
    <div className="w-screen h-screen overflow-hidden flex flex-col dark-mode bg-primary">
      <AdminNavbar />
      <div className="p-8 flex-1 min-h-0 flex flex-col">{children}</div>
    </div>
  );
};
